export interface Disposable {
  dispose: () => void;
}

export function isDisposable(disposable: any): disposable is Disposable {
  return disposable.dispose !== undefined;
}
